import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { GetPendingPointScheduleResponse } from 'viewup-api/v2';

export const getPendingPointSchedule = async (): Promise<GetPendingPointScheduleResponse> => {
  const response = await serviceApi.point.getPendingPointSchedule(withServiceRequestDefaults());

  return response.data;
};
